"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleErrorMessage = void 0;
const GoogleErrorMessage = {
  // Error google auth returns when user tries to sign-in with 3rd party cookies blocked
  IFRAME_INITIALIZATION_FAILED: "idpiframe_initialization_failed"
};
exports.GoogleErrorMessage = GoogleErrorMessage;